import { render, staticRenderFns } from "./CrearReceta.vue?vue&type=template&id=b8891f62"
import script from "./CrearReceta.vue?vue&type=script&lang=js"
export * from "./CrearReceta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports